import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import AboutCreditBanner from '../../../assets/about-us/about-credit-banner.jpg'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMAboutCredit: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Box sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                paddingRight: isTablet ? '20px' : '48px',
            }}>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'}>
                    {t('t98')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px': '40px'}>
                    {t('t99')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={isTablet ? '20px' : '40px'}>
                    {t('t100')}
                </Typography>
            </Box>

            <Box>
                <Image src={AboutCreditBanner} width={isTablet ? 460 : 636} height={isTablet ? 396 : 548} alt='' style={{ objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAboutCredit
